export default __webpack_public_path__ + "static/media/restaurant-5-rMIN.a7af289c.jpg";